import React, { Component } from 'react';
import imgBanner from '../../common/images/about/about-banner.jpg';
import imgFaZhan2 from '../../common/images/about/fazhan2.png';
import imgFaZhan3 from '../../common/images/about/fazhan3.png';
import imgFaZhan4 from '../../common/images/about/fazhan4.png';
import imgPicture2 from '../../common/images/about/picture2.png';
import imgPicture3 from '../../common/images/about/picture3.png';
import imgCulture from '../../common/images/about/culture.png';
import imgPicture6 from '../../common/images/about/picture6.png';
import imgPicture7 from '../../common/images/about/picture7.png';
import imgPicture8 from '../../common/images/about/picture8.png';
import imgPicture9 from '../../common/images/about/picture9.png';
import imgPicture13 from '../../common/images/about/picture13.png';
import imgPicture14 from '../../common/images/about/picture14.png';

import Title from '../../component/title/index';
import Title2 from '../../component/title2/index';
// import Team from './index/team';
import Team2 from './index/team2';
import './style.less';

// @withRouter
class About extends Component {
  render() {
    // const layout4 = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };
    // const layout6 = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };
    return (
      <div className='about'>
        <div className='banner'>
          <img src={imgBanner} alt='菜小秘' />
        </div>
        <div className='content2'>
          <Title2>公司简介</Title2>
          <div className='container'>
            <p>
              武汉智易农批科技有限公司成立于2018年，深耕行业8年，已成为国内领先的农贸流通领域数字化服务商。公司依托大数据、云计算及供应链金融技术，构建“互联网+农批”产业新生态，支持年交易额超千亿的生鲜流通场景‌，连续6年荣获“国家高新技术企业”“瞪羚企业”认证‌。
            </p>
            <p>
              旗下品牌“菜小秘”，是专为农贸批发配送行业打造的开单收银记账管理软件，核心功能包括智能语音开单、全流程赊欠管理、库存管理、批次利润、票据打印、上下游对账、财务报表等，支持自营、代卖、批发、配送多种模式，适配蔬菜、水果、水产、肉类、干货等行业使用，通过提供多角色协同、软硬件智能互联、全流程数字化运营的一体化解决方案，已成功帮助70000+农批经营商户实现降本增效、赊欠风控、高效获客和数字化转型。‌
            </p>
            <p>
              旗下品牌“农可以”，是专为产地货主打造的智能记账和经营管理软件，针对产地经营管理难题，提供智能收发货记账、一键对账结算、全流程数字化管理解决方案，帮助产地货主高效、清晰、准确管理每一笔资金与交易，让产地生意更简单。
            </p>
          </div>
        </div>
        <div className='content3'>
          <Title>发展历程</Title>
          <div className='container'>
            <div>
              <div className='c3-img'>
                <img src={imgFaZhan2} alt='' />
              </div>
              <div className='c3-date'>
                <span>2018</span>
                <span>2019</span>
                <span>2020</span>
              </div>
              <div className='c3-text'>
                <div className='c3-text-1'>初创启航</div>
                <div className='c3-text-2'>
                  <div>
                    <span className='c3-text-2-date'>2018年</span>
                    <span>公司成立，“菜小秘”上线，并完成天使轮融资</span>
                  </div>
                  <div>
                    <span className='c3-text-2-date'>2019年</span>
                    <span>获智慧城市创新创业“华中优秀项目”，完成千万级Pre-A轮融资</span>
                  </div>
                  <div>
                    <span className='c3-text-2-date'>2020年</span>
                    <span>获“国家高新技术企业”“瞪羚企业”认证</span>
                  </div>
                </div>
                <div className='c3-text-3'></div>
              </div>
            </div>
            <div>
              <div className='c3-text'>
                <div className='c3-text-1'>规模扩张</div>
                <div className='c3-text-2'>
                  <div>
                    <span className='c3-text-2-date'>2021年</span>
                    <span>组建“菜小秘”客户成功团队，升级服务体系</span>
                  </div>
                  <div>
                    <span className='c3-text-2-date'>2022年</span>
                    <span>拓展农批水果市场，支付功能上线</span>
                  </div>
                  <div>
                    <span className='c3-text-2-date'>2023年</span>
                    <span>客户覆盖上下游100万用户，客户遍布全国31省（市、区）农批节点</span>
                  </div>
                </div>
                <div className='c3-text-3'></div>
              </div>
              <div className='c3-date'>
                <span>2021</span>
                <span>2022</span>
                <span>2023</span>
              </div>
              <div className='c3-img'>
                <img src={imgFaZhan3} alt='' />
              </div>
            </div>
            <div>
              <div className='c3-img'>
                <img src={imgFaZhan4} alt='' />
              </div>
              <div className='c3-date'>
                <span>2024</span>
                <span>2025</span>
                <span>2026</span>
              </div>
              <div className='c3-text'>
                <div className='c3-text-1'>创新布局</div>
                <div className='c3-text-2'>
                  <div>
                    <span className='c3-text-2-date'>2024年</span>
                    <span>拓展农批水产市场，推出每日菜价数据服务</span>
                  </div>
                  <div>
                    <span className='c3-text-2-date'>2025年</span>
                    <span>创“农可以”品牌布局产地信息化，催款业务上线</span>
                  </div>
                  <div>
                    <span className='c3-text-2-date'>2026年</span>
                    <span>拓展生鲜配送市场，杭州分公司成立，开启新征程…</span>
                  </div>
                </div>
                <div className='c3-text-3'></div>
              </div>
            </div>
          </div>
        </div>
        <div className='content4'>
          <Title>创始团队</Title>
          <div className='container'>
            <div className='team2-warp'>
              <Team2
                name='李东林'
                img={imgPicture3}
                title='联合创始人&CEO'
                intro='毕业于上海同济大学。36氪专栏作者。原ADP大中华区产品负责人；iCamp兼职投资合伙人；经验十足，15年B端产品管理、产品运营经验，是TO B SaaS，TO C移动互联网领域的连续创业者。'
              />
              <Team2
                name='张建林'
                img={imgPicture2}
                title='项目早期发起人'
                intro='湖北经济学院酒店管理专业，高级物流师职称。武汉市农业产业重点龙头企业—武汉兴农方信农业公司创办人、总经理；武汉蔬菜协会副会长；20年生鲜农产品流通行业经验。'
              />
              <Team2
                name='杨发强'
                img={imgPicture6}
                title='首席架构师'
                intro='华为及武汉烽火信息平台部技术架构师；曾参与多个行业SaaS的架构设计和微服务架构设计，对大数据处理有多年的经验积累。'
              />
            </div>
            <div className='team2-warp'>
              <Team2
                name='龚凡'
                img={imgPicture8}
                title='技术总监'
                intro='华中科技大学本硕；10年技术开发与项目管理经验，先后参与或主导过ToC电商系统和ToB政企系统的建设与交付，积累了丰富的经验。'
              />
              <Team2
                name='陈明'
                img={imgPicture13}
                title='财务负责人'
                intro='武汉大学财务专业本科；大型国企多年财务管理经验，珠海基金财务部总经理，CPA注册会计师，CFA特许金融分析师。'
              />
              <Team2
                name='唐如孙'
                img={imgPicture14}
                title='大数据服务专家'
                intro='纽约州立大学石溪分校计算机硕士；10+年华尔街投行、对冲基金工作经验；2014年回国创业；专注供应链数字化、自动化、区块链技术应用。'
              />
              <Team2
                name='艾文'
                img={imgPicture7}
                title='客户成功总监'
                intro='百度高级产品经理；中纺智能制造E系统产品负责人；淘纱网撮合交易平台产品总监；对B2B交易环节的分级会员体系、中心仓储管理、物流配送等丰富的产品设计经验。'
              />
            </div>
          </div>
        </div>
        <div className='content5'>
          <div className='c5-1'>企业文化</div>
          <div className='c5-2'>以客户为中心</div>
          <div className='c5-3'>给中国农业从业者提供最好用的数字化工具</div>
          <div className='c5-img'>
            <img src={imgCulture} alt='' />
          </div>
        </div>
      </div>
    );
  }
}

export default About;
